import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {TradingInstrumentDisplayNameService} from '../trading-instruments/trading-instrument-display-name.service';

export interface OrderPreviewLeg {
    kind: number;
    ticker: string;
    qty: number; // signed position or trade; zero positions render blank
    type?: string;
    expiration?: string;
    strike?: number;
    cursorDay?: string;
    action?: string;
    fillPx?: number;
    marketPx?: number;
}

export interface OrderPreviewTables {
    before: OrderPreviewLeg[];
    transaction: OrderPreviewLeg[];
    after: OrderPreviewLeg[];
}

@Component({
    selector: 'ets-order-preview-tables',
    templateUrl: './order-preview-tables.component.html',
    styleUrls: ['./order-preview-tables.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderPreviewTablesComponent {
    constructor(private readonly displayNames: TradingInstrumentDisplayNameService) {}
    @Input() tables: OrderPreviewTables;
    @Input() isAsset = false;
    @Input() acquiring = false;
    @Input() busy = false;
    @Output() fillChanged = new EventEmitter<{index: number; value: number}>();
    readonly centerText = {style: 'text-align: center'};

    // Transaction order is fixed during entry. Keep the editor when PH/A projects fresh leg objects;
    // ticker alone is not unique (manual reversals can close and open the same instrument).
    trackTransaction(index: number): number { return index; }

    side(qty: number): string { return qty > 0 ? 'Long' : qty < 0 ? 'Short' : ''; }
    magnitude(qty: number): number | string { return qty === 0 ? '' : Math.abs(qty); }
    tickerText(ticker: string): string { return this.displayNames.getDisplayNameForTicker(ticker); }
    marketText(leg: OrderPreviewLeg): string {
        return leg.marketPx == null || !isFinite(leg.marketPx) ? '' : '$' + leg.marketPx.toFixed(2);
    }
}
